import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import SearchBar from '../components/SearchBar';
import Tabs from '../components/Tabs';
import TabContent from '../components/TabContent';
import ApiNavigation from '../components/ApiNavigation';
import ExampleNavigation from '../components/ExampleNavigation';

var LNB = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LNB, _React$Component);

  function LNB() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = LNB.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        useExample = _this$props.useExample,
        tabIndex = _this$props.tabIndex,
        selectedNavItemId = _this$props.selectedNavItemId,
        width = _this$props.width;
    return /*#__PURE__*/React.createElement("aside", {
      className: "lnb",
      style: {
        width: width
      }
    }, /*#__PURE__*/React.createElement(SearchBar, null), useExample ? /*#__PURE__*/React.createElement(Tabs, {
      tabIndex: tabIndex
    }, /*#__PURE__*/React.createElement(TabContent, {
      name: "API"
    }, /*#__PURE__*/React.createElement(ApiNavigation, {
      selectedId: selectedNavItemId
    })), /*#__PURE__*/React.createElement(TabContent, {
      name: "Examples"
    }, /*#__PURE__*/React.createElement(ExampleNavigation, {
      selectedId: selectedNavItemId
    }))) : /*#__PURE__*/React.createElement(ApiNavigation, {
      selectedId: selectedNavItemId
    }));
  };

  return LNB;
}(React.Component);

export default LNB;